export default "skymp5-front/1ac0b15a16905180eb344e8b3552f3a2.png";